export default __webpack_public_path__ + "static/media/Arjun Batra.579a2195.jpg";